// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3Q5eC","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3BFfz"};